module.exports = __webpack_public_path__ + "media/src/images/partners/esf-0f2506b75fd7d646182c72ccf7bba1a6.jpg";